import { PUBLIC_TRUSTARC_DOMAIN } from '$env/static/public';

export const MARKETS = Object.freeze({
    DE: 'de',
    EN: 'en',
    ENCA: 'en-ca',
    ENGB: 'en-gb',
    ENNZ: 'en-nz',
    ES: 'es',
    FI: 'fi',
    IE: 'ie',
    JP: 'ja',
    NO: 'no',
    ROW: 'row',
    SV: 'sv',
    ROG: 'rog',
    ON: 'on'
    /* NEW_MARKET */
}) as Record<string, string>;

export const ISO_639_2_LANGS = Object.freeze({
    [MARKETS.DE]: 'de',
    [MARKETS.EN]: 'en',
    [MARKETS.ENCA]: 'en',
    [MARKETS.ENGB]: 'en',
    [MARKETS.ENNZ]: 'en',
    [MARKETS.ES]: 'es',
    [MARKETS.FI]: 'fi',
    [MARKETS.IE]: 'en',
    [MARKETS.JP]: 'ja',
    [MARKETS.NO]: 'no',
    [MARKETS.ROW]: 'en',
    [MARKETS.ROG]: 'en',
    [MARKETS.SV]: 'sv',
    [MARKETS.ON]: 'en'
    /* NEW_MARKET */
}) as Record<string, string>;

export const CONSENT_DECISION_NAME = 'getConsentDecision';

export const CONSENT_GDPR_DECISION_NAME = 'getGDPRConsentDecision';

export const ALLOWED_CONSENT_TYPES_NAMES = [
    'Any',
    'Required',
    'Functional',
    'Advertising',
    'Social Media'
];

export const CONSENT_PARAMS = {
    c: 'teconsent',
    gtm: 1,
    domain: PUBLIC_TRUSTARC_DOMAIN,
    text: true,
    behavior: 'expressed'
};

export const CONSENT_IMPLIED_PARAMS = {
    js: 'nj',
    noticeType: 'bb',
    behavior: 'implied'
};

export const TRUSTARC_LOAD_RETRIES = 5;
export const TRUSTARC_LOAD_RETRY_INTERVAL = 500;
